const TransactionResult = {
  SUCCESS: 'success',
  NOT_ALLOWED: 'notallowed',
  FAILED: 'failed',
};

export { TransactionResult };
